import React from 'react';

import {
	Wrapper,
	Title,
	Text,
	Action,
	StyledButton,
} from './TooltipContent.styles';

export const TooltipContent = ({ title, text, buttonText, handleClick }) => {
	return (
		<Wrapper>
			<Title>{title}</Title>
			<Text>{text}</Text>
			<Action>
				<StyledButton onClick={handleClick}>{buttonText}</StyledButton>
			</Action>
		</Wrapper>
	);
};
